exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".articles-page{margin:0 3hv;width:auto}.articles-page .markdown{font-size:1.1rem;line-height:1.45}.articles-page .markdown p{line-height:1.45}.articles-page .markdown img{display:block;width:80%;margin:2rem auto}.articles-page header{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;border-bottom:1px solid #e4e7ed;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;flex-flow:row wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-bottom:.5rem;width:100%}.articles-page header h1{width:auto}.articles-page header .meta{color:#909399;font-size:.8rem;margin-left:1rem;padding:.3rem 0;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3a30b382","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/articles-page.vue
// module id = uJNg
// module chunks = 1